import ImagePickerControl from './ImagePickerControl'
import NavigationBarControl from './NavigationBarControl'

export default class SelectImage {
  constructor (element, args) {
    let fragment = document.createDocumentFragment()
    

    new NavigationBarControl(fragment, {
      title: 'Kies afbeelding',
      leftHandButtons: [{
        onclick: () => {
          if (args.oncancel) {
            window.removeEventListener('paste', this.pasteHandler)
            args.oncancel()
          }
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            if (args.onok) {
              window.removeEventListener('paste', this.pasteHandler)
              args.onok(this.results.getImage())
            }
          },
          icon: '\ue11e'
        }],
      contextMenu: [
        {
          onclick: () => {
            if (this.select) {
              this.select()
            }
          },
          icon: '\ue08d',
          label: 'Kies afbeelding'
        },
        /*{
            onclick: () => {
                if (this.rotate) {
                    this.rotate()
                }
            },
            icon: '\ue0da',
            label: 'Afbeelding draaien'
        },*/
        {
          onclick: () => {
            if (this.clear) {
              this.clear()
            }
          },
          icon: '\ue03d',
          label: 'Geen afbeelding'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport composer'

    this.results = new ImagePickerControl(div, {image: args.image})
    fragment.appendChild(div)

    this.select = this.results.onselect.bind(this.results)
    //this.rotate = this.results.onrotate.bind(this.results)
    this.clear = this.results.clearImage.bind(this.results)
    this.pasteHandler = this.results.pasteHandler.bind(this.results)

    window.addEventListener('paste', this.pasteHandler)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/SelectImage.js